import { useCallback, useRef, useState } from 'react';
import type { FinalReviewSection } from '../../../../services/finalReview';

// Unsectioned lists (the orthodontist's feedback) leave section out.
export interface DraftNote {
    id: string;
    text: string;
    section?: FinalReviewSection;
}

// Local until Hand back sends them; nothing is saved in between.
export function useDraftNotes() {
    const [notes, setNotes] = useState<DraftNote[]>([]);
    const lastId = useRef(0);

    const addNote = useCallback((section?: FinalReviewSection) => {
        lastId.current += 1;
        const id = `note-${lastId.current}`;
        setNotes((prev) => [...prev, { id, text: '', ...(section && { section }) }]);
    }, []);

    const updateNote = useCallback((id: string, text: string) => {
        setNotes((prev) => prev.map((n) => (n.id === id ? { ...n, text } : n)));
    }, []);

    const removeNote = useCallback((id: string) => {
        setNotes((prev) => prev.filter((n) => n.id !== id));
    }, []);

    return { notes, addNote, updateNote, removeNote };
}
